<template>
    <div class="row">
    <template  v-if="!showThankYou">
      <div class="col-sm-12">
        <h4 class="info-text ">
          Confirm your requirements
        </h4>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <div class="form-row">
            <div class="col">
              <label class="form-label required">Source currency</label>
              <vue-select
                class="vue-select"
                name="sourceCurrency"
                :options="currencies"
                :class="{ error: errors.has('stepCurrencyPref.sourceCurrency') }"
                label="CurrencyName"
                v-model="sourceCurrency"
                data-vv-scope="stepCurrencyPref"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CurrencyCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  {{ option.CurrencyName }}
                </template>
              </vue-select>
            </div>
            <div class="col">
              <label class="form-label required">Target currency</label>
              <vue-select
                class="vue-select"
                name="targetCurrency"
                :options="currencies"
                :class="{ error: errors.has('stepCurrencyPref.targetCurrency') }"
                label="CurrencyName"
                v-model="targetCurrency"
                data-vv-scope="stepCurrencyPref"
                v-validate="'required'"
                autocomplete="none"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="long-and-truncated-with-child-corrected">
                      <span>{{ option.CurrencyCode }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  {{ option.CurrencyName }}
                </template>
              </vue-select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Amount</label>
          <input
            name="transferAmount"
            type="number"
            class="form-control"
            :class="{ error: errors.has('stepCurrencyPref.transferAmount') }"
            placeholder="Amount"
            v-model.trim="transferAmount"
            data-vv-scope="stepCurrencyPref"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Transfer destination</label>

          <vue-select
            class="vue-select"
            name="transferDestination"
            :options="countries"
            :class="{ error: errors.has('stepCurrencyPref.transferDestination') }"
            label="CountryName"
            v-model="transferDestination"
            data-vv-scope="stepCurrencyPref"
            v-validate="'required'"
            autocomplete="none"
          >
            <template slot="selected-option" slot-scope="option">
              <div class="flex">
                <div class="long-and-truncated-with-child-corrected">
                  <span>{{ option.CountryName }}</span>
                </div>
              </div>
            </template>
            <template slot="option" slot-scope="option">
              <span
                class="flag-icon flag-icon-squared"
                :class="('flag-icon-' + option.TwoCharCode) | lowerCase"
              ></span
              >&nbsp;
              {{ option.CountryName }}
            </template>
          </vue-select>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label class="form-label required">Reason for transfer</label>
          <select
            name="reasonForTransfer"
            class="form-control custom-select"
            required
            v-model.trim="reasonForTransfer"
            :class="{ error: errors.has('stepCurrencyPref.reasonForTransfer') }"
            data-vv-scope="stepCurrencyPref"
            v-validate="'required'"
          >
            <option
              :value="rft.CodesId"
              v-for="(rft, index) in rfts"
              :key="index"
              >{{ rft.SelectionValue }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-sm-12" v-if="showAboutUs">
        <div class="form-group">
          <label class="form-label">How did you hear about us</label>
          <select
            name="referral"
            class="form-control custom-select"
            v-model.trim="referralSource"
          >
            <option value="">Select...</option>
            <option value="44">Employee</option>
            <option value="43">Recommended by a friend</option>
            <option value="39">Google</option>
            <option value="40">Shows and exhibitions</option>
            <option value="2004">Social Networking</option>
            <option value="2898">AI Search</option>
            <option value="223">Others</option>
          </select>
        </div>
      </div>

      <div class="col-sm-12">
        <message-info />
      </div>
      <div class="col-sm-12 mt-3">
        <input
          type="button"
          class="btn btn-fill btn-success btn-block btn-wd btn-md"
          name="save"
          value="Finish"
          @click.prevent="save()"
        />
      </div>
      <div class="col-sm-12 mt-2">
        <hr />
         <privacy-policy />
      </div>
    </template>
    <template v-else>
     <message-box :type="4" />
      <datetime-picker v-if="isGBGVerified" :gbgverified="isGBGVerified"/>
    </template>
      <Loading v-if="loading" />
    </div>
</template>
<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import MessageInfo from "@/components/ui/MessageInfo.vue";
import mixin from "@/components/shared/mixinUtility";
import { trackRegistrationCompleted } from "@/helper/datadog";
import Loading from "@/components/ui/Loading.vue";
import axios from "axios";
import MessageBox from "@/components/ui/MessageBox.vue";
import DateTimePicker from '@/components/ui/DateTimePicker.vue';
import PrivacyPolicy from '@/components/ui/PrivacyPolicy.vue';
export default {
  name: "Preference",
  mixins: [mixin],
  data() {
    return {
      loading: false,
      showAboutUs: true,
      showThankYou:false
    };
  },
  computed: {
    ...mapFields([
      "form.sourceCurrency",
      "form.targetCurrency",
      "form.transferAmount",
      "form.transferDestination",
      "form.reasonForTransfer",
      "form.referralSource",
      "budgetToValueMapping"
    ]),
    ...mapGetters({
      currentActive: "getCurrentActive",
      formData: "getFormData",
      actions: "getActions",
      currencies: "getCurrencies",
      countries: "getCountries",
      rfts: "getRfts",
      contactId: "getContactId",
      jwtToken:"getJwtToken"
    }),
     
  },
  components: {
    "vue-select": VueSelect,
    "message-info": MessageInfo,
    Loading,
     "message-box": MessageBox,
      "datetime-picker":DateTimePicker,
       "privacy-policy": PrivacyPolicy,
  },
  methods: {
    save() {
      this.resetMessageInfo();
      this.$root.$validator
        .validate("stepCurrencyPref.*")
        .then(async (valid) => {
          if (valid) {
            try {
              //check for source/target currency
              if (this.sourceCurrency == this.targetCurrency) {
                this.showGenericErrorMessage(
                  "Source/Target Currency can't be the same.",
                  false
                );
                return false;
              }
              this.loading = true;
              const data = await this.confirmDetails();

              if (data.status.toLowerCase() == "ok") {
                //saved
                this.loading = false;
                trackRegistrationCompleted();
                this.showThankYou=true;
                //window.location.href ="https://www.youroverseashome.com/thankyou-events/";
                // //if mobile verified and gbg verified they can create an ONline account
                // if (
                //   this.actions.isMobileVerified &&
                //   this.actions.isGBGVerified
                // ) {
                //   //generate token and redirect to FTL
                //   const token = await this.generateToken(this.contactId);
                //   //redirect to first time login
                //   this.$router.push({
                //     name: "FirstLogin",
                //     params: { tokenvalue: token },
                //   });
                // } else {
                //   //redirect to thank you page
                //   window.top.location.href =
                //     "https://www.smartcurrencyexchange.com/applyonline/thankyou/";
                // }
                // this.loading = false;
              } else {
                this.showGenericErrorMessage(
                  "We've encountered a problem.",
                  false
                );
                this.loading = false;
              }
            } catch (ex) {
              this.showGenericErrorMessage(
                "We've encountered a problem.",
                false
              );
              this.loading = false;
            }
            //all valid?
          } else {
            //not valid
            this.showGenericErrorMessage(
              "Please enter all mandatory fields.",
              false
            );
          }
        });
    },
    async confirmDetails() {
      const payload = {
        contactId: this.contactId,
        countryId: parseInt(this.formData.transferDestination.CRMCountryId),
        sourceCurrency: this.formData.sourceCurrency.CurrencyCode,
        targetCurrency: this.formData.targetCurrency.CurrencyCode,
        targetAmount: parseFloat(this.formData.transferAmount),
        reasonForTransferId: parseInt(this.formData.reasonForTransfer),
        sourceSite: this.formData.sourceSiteForPreference,
        referralSource: this.formData.referralSource,
        referralEmployeeId: this.formData.referredByEmpId,
        referrerById: this.formData.referredBy,
        bizId: this.formData.bizId,
        isContactExist: this.formData.isContactExist,
      };

      const { data } = await axios.post(
        process.env.VUE_APP_API_URL + "/client/ConfirmDetails",
        payload,
         { headers: { Authorization: `Bearer ${this.jwtToken}` } }
      );

      return data;
    },
  },
  created() {
      this.resetMessageInfo();
    this.$store.dispatch("setHideNavigation", true);
    this.showAboutUs =
      this.formData.referralSource == "501" ||
      this.formData.referralSource == "";
      console.log( this.formData.countryBuyingIn.CountryId)
    this.formData.transferDestination = this.formData.countryBuyingIn;

    // Pre-populate the transfer amount using the budget selected before
    const budgetValue = this.budgetToValueMapping[this.formData.propertyBudget] || "";
    this.formData.transferAmount = budgetValue;
  },
};
</script>
